/**
 * The API surfaces real, actionable reasons ("Subscription has been canceled.
 * Resubscribe to continue using certificates."). parseApiError already puts
 * them on Error.message, but catch blocks were discarding that and showing a
 * generic "Couldn't issue the certificate", so the user could not tell a
 * billing problem from a network blip.
 */
export function errorMessage(err: unknown): string {
  if (err instanceof Error && err.message.trim()) return err.message.trim();
  if (typeof err === "string" && err.trim()) return err.trim();
  return "";
}

/** Billing problems need a route to the fix, not just an explanation. */
export function isSubscriptionError(message: string): boolean {
  return /subscription|resubscribe|cancell?ed|expired plan|no active plan/i.test(message);
}
